module.exports = __webpack_public_path__ + "media/images/let-you-screen/whatsapp-cf6f3aea472f6524ce25dcdd166bbced.svg";